export default __webpack_public_path__ + "static/media/P10024.780c3b7c.png";